var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2823_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2406 18.3959H18.9392V9.99815H23.2131L16.0899 3L8.96662 9.99815H13.2406V18.3959ZM29.3932 20.5401C29.0941 20.2266 27.0981 18.1286 26.5283 17.5813C26.1289 17.2053 25.597 16.9956 25.0438 16.9963H22.5407L26.9058 21.1868H21.8568C21.7882 21.1855 21.7205 21.2021 21.6605 21.2348C21.6004 21.2675 21.5502 21.3151 21.5149 21.3729L20.3524 23.9944H11.8273L10.6648 21.3729C10.6293 21.3153 10.579 21.2678 10.5191 21.2352C10.4591 21.2025 10.3915 21.1858 10.3229 21.1868H5.27393L9.63763 16.9963H7.13595C6.57036 16.9963 6.03042 17.2188 5.65146 17.5813C5.0816 18.13 3.08567 20.228 2.78649 20.5401C2.08984 21.2694 1.70661 21.8502 1.88896 22.5682L2.68819 26.8707C2.87055 27.5901 3.67262 28.1807 4.47185 28.1807H27.7107C28.51 28.1807 29.312 27.5901 29.4944 26.8707L30.2936 22.5682C30.4731 21.8502 30.0913 21.2694 29.3932 20.5401Z",
    fill: "#672F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2823_174",
    x: 0.518449,
    y: 0.349398,
    width: 33.7953,
    height: 30.4809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.3253
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3253
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2823_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2823_174",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.79f6bc7464db2459829bb10d8459dd54.svg";
export { ForwardRef as ReactComponent };